import React from 'react';

// Beginner-friendly, Hinglish, step-by-step Meta (Facebook + WhatsApp) setup guide.
// Goal: a first-timer only logs into Facebook, then follows direct links to grab each value.

const STEPS = [
  {
    n: 0,
    title: 'सबसे पहले — अपने Facebook पर Login कीजिए',
    desc: 'जिस Facebook account से आप business चलाते हैं, उसी से login रहिए। बाकी सब इसी account से जुड़ेगा।',
    fields: [
      { label: 'Facebook Email ID', what: 'जिस email/number से Facebook login करते हैं — कहीं भरना नहीं, बस याद रखें।', link: 'https://www.facebook.com/', linkText: '🔗 Facebook खोलें', required: false },
    ],
  },
  {
    n: 1,
    title: 'Business Portfolio (Business Manager) खोलें',
    desc: 'यह आपके business का घर है — यहीं से Ad Account, Page, Token सब मिलेगा। पहली बार हैं तो "Create a business portfolio" करके अपना business बना लीजिए।',
    fields: [
      { label: 'Business Portfolio Name', what: 'आपके business का नाम (जैसे "Sunrise School")।', link: 'https://business.facebook.com/settings/info', linkText: '🔗 Business Info खोलें', required: false },
      { label: 'Business Portfolio ID', what: 'Business Settings → Business Info पेज पर सबसे ऊपर एक लंबा नंबर — वही ID है।', link: 'https://business.facebook.com/settings/info', linkText: '🔗 Business Info खोलें', required: false },
      { label: 'Legal Business Name', what: 'आपके स्कूल/संस्था का कानूनी नाम — इसी Business Info पेज पर।', link: 'https://business.facebook.com/settings/info', linkText: '🔗 Business Info खोलें', required: false },
      { label: 'Business Email', what: 'Business का official email — इसी Business Info पेज पर।', link: 'https://business.facebook.com/settings/info', linkText: '🔗 Business Info खोलें', required: false },
      { label: 'Website', what: 'आपके स्कूल की website (नहीं है तो shiksha-mitra.com वाला public profile डाल सकते हैं)।', link: null, required: false },
    ],
  },
  {
    n: 2,
    title: 'Ad Account ID लीजिए',
    desc: 'Facebook ads चलाने के लिए ज़रूरी। Business Settings → Accounts → Ad accounts खोलिए, अपना ad account चुनिए।',
    fields: [
      { label: 'Ad Account ID ⭐', what: 'ad account के नाम के नीचे एक नंबर दिखेगा (act_ के बाद वाला सिर्फ़ नंबर copy करें)।', link: 'https://business.facebook.com/settings/ad-accounts', linkText: '🔗 Ad Accounts खोलें', required: true, appField: 'Ad Account ID' },
    ],
  },
  {
    n: 3,
    title: 'Facebook Page चुनिए',
    desc: 'जिस Page से ads/messages जाएँगे। Business Settings → Accounts → Pages खोलिए।',
    fields: [
      { label: 'Facebook Page Name', what: 'आपके स्कूल का Facebook Page नाम।', link: 'https://business.facebook.com/settings/pages', linkText: '🔗 Pages खोलें', required: false },
      { label: 'Facebook Page ID ⭐', what: 'Page चुनिए → उसका ID (नंबर) copy करें।', link: 'https://business.facebook.com/settings/pages', linkText: '🔗 Pages खोलें', required: true, appField: 'Page ID' },
    ],
  },
  {
    n: 4,
    title: 'Meta App बनाइए (Developer Dashboard)',
    desc: 'developers.facebook.com → "Create App" → type में "Business" चुनिए → app बना लीजिए। फिर App → Settings → Basic खोलिए।',
    fields: [
      { label: 'App Name', what: 'आपकी app का नाम (कुछ भी, जैसे "Sunrise WhatsApp")।', link: 'https://developers.facebook.com/apps/', linkText: '🔗 Apps खोलें', required: false },
      { label: 'App ID ⭐', what: 'App → Settings → Basic पेज पर सबसे ऊपर "App ID" दिखेगा।', link: 'https://developers.facebook.com/apps/', linkText: '🔗 Apps → Settings → Basic', required: true, appField: '(advanced)' },
      { label: 'App Secret ⭐', what: 'इसी Basic पेज पर "App Secret" → "Show" दबाकर copy करें (इसे किसी से share न करें)।', link: 'https://developers.facebook.com/apps/', linkText: '🔗 Apps → Settings → Basic', required: true, appField: '(advanced)' },
      { label: 'App Contact Email', what: 'इसी Basic पेज पर "Contact Email"।', link: 'https://developers.facebook.com/apps/', linkText: '🔗 Apps → Settings → Basic', required: false },
    ],
  },
  {
    n: 5,
    title: 'WhatsApp को App में जोड़िए',
    desc: 'App Dashboard में बाएँ मेन्यू से "Add Product" → WhatsApp → "Set up" दबाइए। फिर WhatsApp → "API Setup" पेज खोलिए — यहीं सब WhatsApp values मिलेंगी।',
    fields: [
      { label: 'WhatsApp Business Account Name', what: 'API Setup पेज पर आपका WABA नाम दिखेगा।', link: 'https://developers.facebook.com/apps/', linkText: '🔗 App → WhatsApp → API Setup', required: false },
      { label: 'WhatsApp Business Account ID ⭐', what: 'API Setup पेज पर "WhatsApp Business Account ID" — copy करें।', link: 'https://developers.facebook.com/apps/', linkText: '🔗 App → WhatsApp → API Setup', required: true, appField: 'WhatsApp Business Account ID' },
      { label: 'Phone Number ID ⭐', what: 'API Setup पेज पर "Phone number ID" — यह आपके फ़ोन नंबर से अलग एक ID है, इसे copy करें।', link: 'https://developers.facebook.com/apps/', linkText: '🔗 App → WhatsApp → API Setup', required: true, appField: 'WA Phone Number ID' },
    ],
  },
  {
    n: 6,
    title: 'Permanent Token बनाइए (सबसे ज़रूरी ⭐)',
    desc: 'API Setup वाला token सिर्फ़ 24 घंटे चलता है। इसलिए एक "System User Token" बनाइए जो हमेशा चले। Business Settings → Users → System Users खोलिए।',
    fields: [
      { label: 'System User Token = WhatsApp Access Token ⭐', what: '"Add" → System User बनाइए (role: Admin) → "Generate New Token" → अपनी App चुनिए → ये permissions ☑️ करें: whatsapp_business_messaging, whatsapp_business_management, ads_management, business_management, pages_read_engagement → "Generate Token" → token copy कर के सुरक्षित रखें। यही एक token Facebook Ads और WhatsApp — दोनों के लिए काम करेगा।', link: 'https://business.facebook.com/settings/system-users', linkText: '🔗 System Users खोलें', required: true, appField: 'Access Token (FB + WA दोनों)' },
    ],
  },
  {
    n: 7,
    title: 'Facebook Page को WhatsApp से Link कीजिए (WhatsApp ads के लिए ज़रूरी)',
    desc: 'जब आप "WhatsApp Chats" वाला ad बनाते हैं और लाल warning आए — "Your Page is not linked to a WhatsApp account" — तो इसका मतलब आपका Facebook Page आपके WhatsApp नंबर से जुड़ा नहीं है। इसे एक बार link करना ज़रूरी है, तभी ads लोगों को सीधे आपके WhatsApp पर भेज पाएँगे।',
    fields: [
      { label: 'तरीका 1 — Business Settings से', what: 'Business Settings → Accounts → WhatsApp Accounts → अपना WhatsApp account चुनिए → "Connected assets / Add assets" में अपना Facebook Page जोड़िए।', link: 'https://business.facebook.com/settings/whatsapp-business-accounts', linkText: '🔗 WhatsApp Accounts खोलें', required: false },
      { label: 'तरीका 2 — Page Settings से (आसान)', what: 'अपना Facebook Page खोलिए → Settings → "Linked accounts" या "WhatsApp" → अपना WhatsApp नंबर डालकर "Send code" → OTP डालकर connect कीजिए। (Meta Business Suite → Settings → WhatsApp से भी हो जाता है।)', link: 'https://business.facebook.com/latest/settings/whatsapp', linkText: '🔗 Business Suite → WhatsApp', required: false },
      { label: 'जाँच लें', what: 'Link होने के बाद Ad Set बनाते समय वह लाल warning गायब हो जाएगा और "WhatsApp Chats" goal सही चुना जा सकेगा।', link: null, required: false },
    ],
  },
];

const PERMISSIONS = [
  { id: 'whatsapp_business_messaging', why: 'WhatsApp messages भेजने के लिए' },
  { id: 'whatsapp_business_management', why: 'WhatsApp account manage करने के लिए' },
  { id: 'ads_management', why: 'Facebook ads चलाने के लिए' },
  { id: 'business_management', why: 'Business portfolio access के लिए' },
  { id: 'pages_read_engagement', why: 'Page की जानकारी पढ़ने के लिए' },
  { id: 'pages_manage_metadata', why: 'Page settings/webhook के लिए' },
];

function PermissionsChecklist() {
  const [copied, setCopied] = React.useState(false);
  const list = PERMISSIONS.map(p => p.id).join(', ');
  const copy = () => {
    navigator.clipboard.writeText(list);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <div className="mx-4 mb-4 mt-1 rounded-xl border border-indigo-200 bg-indigo-50/60 p-3" data-testid="meta-guide-permissions">
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="text-xs font-bold text-indigo-800">✅ Token बनाते समय ये permissions ज़रूर ☑️ करें (एक भी न भूलें):</p>
        <button onClick={copy} data-testid="meta-guide-copy-permissions"
          className="shrink-0 text-xs px-3 py-1.5 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 whitespace-nowrap">
          {copied ? '✓ Copy हो गया' : '📋 सभी copy करें'}
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
        {PERMISSIONS.map(p => (
          <div key={p.id} className="flex items-start gap-2 bg-white rounded-lg border border-indigo-100 px-2.5 py-1.5">
            <span className="text-green-600 text-sm leading-5">☑️</span>
            <div className="min-w-0">
              <p className="font-mono text-[11px] text-slate-800 break-all">{p.id}</p>
              <p className="text-[10px] text-slate-500">{p.why}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-indigo-700 mt-2">💡 Token सिर्फ़ एक बार दिखता है — copy करके सुरक्षित जगह paste कर लें, फिर App के "Access Token" field में डालें।</p>
    </div>
  );
}

const FieldRow = ({ f }) => (
  <div className="flex items-start gap-3 py-2.5 border-b border-slate-100 last:border-0">
    <div className="flex-1">
      <p className="text-sm font-semibold text-slate-800 flex items-center gap-2 flex-wrap">
        {f.label}
        {f.required && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-orange-100 text-orange-700">App में भरना है</span>}
        {!f.required && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-100 text-slate-500">सिर्फ़ जानकारी</span>}
      </p>
      <p className="text-xs text-slate-600 mt-0.5 leading-relaxed">{f.what}</p>
      {f.appField && f.required && (
        <p className="text-[11px] text-blue-600 mt-1">➡️ App field: <b>{f.appField}</b></p>
      )}
    </div>
    {f.link && (
      <a href={f.link} target="_blank" rel="noopener noreferrer"
        className="shrink-0 text-xs px-3 py-1.5 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 whitespace-nowrap"
        data-testid={`meta-guide-link-${f.n}`}>
        {f.linkText || '🔗 खोलें'}
      </a>
    )}
  </div>
);

export default function MetaSetupGuide({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/50 flex items-start justify-center overflow-y-auto p-4" data-testid="meta-setup-guide-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full my-6">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-4 rounded-t-2xl flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold">📘 Meta Connection — Step by Step Guide</h2>
            <p className="text-xs text-blue-100 mt-0.5">पहली बार कर रहे हैं? बस Facebook login कीजिए और नीचे के links से एक-एक value लेकर App में भरते जाइए।</p>
          </div>
          <button onClick={onClose} data-testid="meta-guide-close" className="text-white/90 hover:text-white text-2xl leading-none px-2">×</button>
        </div>

        <div className="px-6 py-5 space-y-5">
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 text-xs text-amber-800">
            ⭐ वाली value <b>App में भरनी ज़रूरी</b> हैं (Ad Account ID, Page ID, App ID, App Secret, WABA ID, Phone Number ID, System User Token)। बाकी सिर्फ़ आपकी जानकारी के लिए हैं। हर value के सामने नीला बटन दबाने पर Meta का सही पेज सीधे खुल जाएगा।
          </div>

          {STEPS.map(step => (
            <div key={step.n} className="border border-slate-200 rounded-xl overflow-hidden">
              <div className="bg-slate-50 px-4 py-3 flex items-start gap-3">
                <span className="shrink-0 w-7 h-7 rounded-full bg-blue-600 text-white text-sm font-bold flex items-center justify-center">{step.n}</span>
                <div>
                  <p className="font-bold text-slate-800 text-sm">{step.title}</p>
                  <p className="text-xs text-slate-600 mt-0.5 leading-relaxed">{step.desc}</p>
                </div>
              </div>
              <div className="px-4">
                {step.fields.map((f, i) => <FieldRow key={i} f={{ ...f, n: `${step.n}-${i}` }} />)}
              </div>
              {step.n === 6 && <PermissionsChecklist />}
            </div>
          ))}

          {/* Final step: fill in app + webhook */}
          <div className="border-2 border-green-300 rounded-xl overflow-hidden">
            <div className="bg-green-50 px-4 py-3 flex items-start gap-3">
              <span className="shrink-0 w-7 h-7 rounded-full bg-green-600 text-white text-sm font-bold flex items-center justify-center">✓</span>
              <div>
                <p className="font-bold text-green-800 text-sm">आख़िरी step — App में भरिए और Test कीजिए</p>
                <p className="text-xs text-slate-600 mt-0.5 leading-relaxed">ऊपर से ली हुई values को नीचे "Meta Connection" form में भरिए:</p>
              </div>
            </div>
            <div className="px-5 py-3 text-xs text-slate-700 space-y-1.5">
              <p>• <b>Ad Account ID</b> → Ad Account ID field</p>
              <p>• <b>Page ID</b> → Page ID field</p>
              <p>• <b>System User Token</b> → Access Token field (Facebook + WhatsApp दोनों यही token use करेंगे)</p>
              <p>• <b>Phone Number ID</b> → WA Phone Number ID field</p>
              <p>• <b>WhatsApp Business Account ID</b> → WA Business Account ID field</p>
              <p className="pt-1">फिर <b>"Meta Connection सेव करें"</b> → <b>"Test Connection"</b> दबाइए। हरा ✅ आ गया तो connection तैयार है!</p>
              <p className="pt-2 text-slate-500">📲 आख़िर में delivery ticks (Delivered/Read) के लिए Lead CRM → 🎟️ Credentials → "Setup" वाले webhook guide को भी follow कर लीजिए।</p>
            </div>
          </div>

          <div className="text-center pt-1">
            <button onClick={onClose} className="px-6 py-2.5 rounded-lg bg-slate-800 text-white text-sm font-medium hover:bg-slate-900" data-testid="meta-guide-done">समझ गया, बंद करें</button>
          </div>
        </div>
      </div>
    </div>
  );
}
